var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"exchange-btn"},'div',_vm.$attrs,false),_vm.$listeners),[_c('img',{staticClass:"arrows",attrs:{"src":require("../images/exchange-arrows.svg")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }